'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNote$() {
  this.aIJ = null;
  this.aIK = false;
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNote$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNote$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNote$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNote$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNote$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNote$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNote$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNote$.prototype = $p;
$p.aA = (function() {
  if ((!this.aIK)) {
    this.aIJ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeString$$anon$1(this);
    this.aIK = true;
  }
  return this.aIJ;
});
$p.ez = (function(input) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeNonEmptyString__validate__T__O(this, input);
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNote$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNote$, "app.data.data_point_types$package$DocumentNote$", ({
  FF: 1,
  B: 1,
  C: 1,
  J: 1,
  M: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNote$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNote$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNote$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNote$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNote$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNote$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNote$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNote$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNote$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNote$ };
//# sourceMappingURL=app.data.data_point_types$package$-Document-Note$.js.map
